import { render, staticRenderFns } from "./ShipmentBatchesList.vue?vue&type=template&id=f4b2daea&scoped=true"
import script from "./ShipmentBatchesList.vue?vue&type=script&lang=js"
export * from "./ShipmentBatchesList.vue?vue&type=script&lang=js"
import style0 from "./ShipmentBatchesList.vue?vue&type=style&index=0&id=f4b2daea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4b2daea",
  null
  
)

export default component.exports